import Marquee from "react-fast-marquee";
import {
  HeartPulse,
  LifeBuoy,
  AlertOctagon,
  Syringe,
  Pill,
  Brain,
  Droplets,
  Wind,
  Bug,
} from "lucide-react";
import { Reveal } from "./Reveal";
import { AnatomicalHeart } from "./icons";
import { useLang } from "@/lib/i18n";

const ICONS = [
  HeartPulse,
  LifeBuoy,
  AlertOctagon,
  Syringe,
  Pill,
  Brain,
  AnatomicalHeart,
  Droplets,
  Wind,
  Bug,
];

export default function TopicsStrip() {
  const { t } = useLang();
  return (
    <div className="mt-8">
      {/* Editorial marquee */}
      <div className="border border-white/10 border-b-0 bg-[#0d0e14] py-4 overflow-hidden">
        <Marquee speed={40} gradient={false} autoFill>
          {t.marquee.map((m, i) => (
            <span key={i} className="flex items-center">
              <span className="mx-8 font-heading text-lg md:text-2xl font-medium uppercase tracking-wide text-white/70">
                {m}
              </span>
              <HeartPulse className={`h-4 w-4 ${i % 2 === 0 ? "text-[#E11B22]" : "text-[#0057B7]"}`} />
            </span>
          ))}
        </Marquee>
      </div>

      {/* Topics icon rectangle */}
      <Reveal
        className="border border-white/10 bg-[#0d0e14] px-4 py-8 md:px-8 md:py-10"
        data-testid="topics-strip"
      >
        <div className="mb-8 flex items-center justify-between gap-4">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-zinc-400">
            {t.topics_label}
          </span>
          <span className="h-px flex-1 bg-white/10" />
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-5 gap-y-8">
          {t.topics.map((label, i) => {
            const Icon = ICONS[i];
            return (
              <div
                key={i}
                data-testid={`topic-${i}`}
                className="group flex flex-col items-center text-center px-2"
              >
                <div className={`flex h-14 w-14 items-center justify-center rounded-full border border-white/10 text-zinc-300 transition-all duration-300 group-hover:-translate-y-1 ${
                  i % 2 === 0
                    ? "group-hover:border-[#0057B7] group-hover:text-[#4d9fff]"
                    : "group-hover:border-[#E11B22] group-hover:text-[#ff5a60]"
                }`}>
                  <Icon className="h-6 w-6" strokeWidth={1.5} />
                </div>
                <span className="mt-3 text-[11px] md:text-xs font-medium uppercase tracking-wide text-zinc-300 leading-tight">
                  {label}
                </span>
              </div>
            );
          })}
        </div>
      </Reveal>
    </div>
  );
}
